import React from "react";

interface PricingCardProps {
  title: string;
  features: { text: string; icon: string }[];
  priceInfo: string;
  subtitle: string;
  buttonText: string;
  onClick: () => void;
  isHighlighted?: boolean;
  isBestValue?: boolean;
  datePass?: boolean;
  isSelected?: boolean; // Add a prop to determine if this card is selected
  cancellationPenalties?: any;
}

const PricingCard: React.FC<PricingCardProps> = ({
  title,
  features,
  priceInfo,
  subtitle,
  onClick,
  isHighlighted,
  isBestValue,
  datePass,
  isSelected,
  cancellationPenalties,
}) => {
  return (
    <div
      className={`flex flex-col justify-between p-4 rounded-lg border shadow-xl flex-grow relative bg-white mb-10 md:mb-0 h-96 hover:border-halo-pink 
      ${isHighlighted ? "border-halo-pink" : "border-gray-300"} 
      ${
        datePass || cancellationPenalties === null
          ? "opacity-50 pointer-events-none bg-gray-100"
          : ""
      }`}
    >
      {datePass && (
        <div className="text-sm text-red-600 mb-2 font-semibold">
          Dates booked must be 40+ days from today
        </div>
      )}

      {cancellationPenalties === null && (
        <div className="text-sm text-red-600 mb-2 font-semibold whitespace-pre-line">
          Sorry, a Free Fare Hold is not available <br/> for the selected dates.
        </div>
      )}
      {isBestValue && (
        <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-halo-pink text-white text-sm font-semibold uppercase py-1 px-3 rounded-lg">
          Best Value
        </div>
      )}
      <h3 className="text-xl font-semibold mt-6">{title}</h3>
      <div className="text-sm">
        {features.map((feature, index) => (
          <p key={index} className="text-black flex items-center">
            <img
              src={feature.icon}
              alt={`${feature.text} icon`}
              className={`${
                feature.icon.includes("tick")
                  ? "-ml-1 w-6 h-6 mr-1"
                  : "w-4 h-4 mr-2"
              }`}
            />
            {feature.text}
          </p>
        ))}
      </div>
      <div className="text-center mt-4 -mb-4">
        <p className="text-black font-bold text-xl">{priceInfo}</p>
        <p>{subtitle}</p>
      </div>
      <button
        type="button"
        onClick={onClick}
        disabled={datePass} // Disable the button if datePass is true
        className={`mt-4 px-4 py-2 rounded-md font-medium border 
        ${
          datePass
            ? "bg-gray-300 text-gray-600 border-gray-300 cursor-not-allowed"
            : isSelected
            ? "bg-halo-pink text-white border-halo-pink"
            : "border-halo-pink text-halo-pink hover:bg-halo-pink hover:text-white"
        }`}
      >
        {datePass ? "40+ days required" : cancellationPenalties === null ? "Not available" : isSelected ? "Selected" : "Select"}
      </button>
    </div>
  );
};

export default PricingCard;
